/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $Video = {
    properties: {
        cropAspectRatio: {
            type: 'number',
        },
        cropX: {
            type: 'number',
        },
        cropY: {
            type: 'number',
        },
        cropScale: {
            type: 'number',
        },
        id: {
            type: 'string',
            isRequired: true,
        },
        uploadDate: {
            type: 'string',
            isRequired: true,
            format: 'date-time',
        },
        uploadedById: {
            type: 'number',
            isRequired: true,
        },
        aspectRatio: {
            type: 'number',
            isRequired: true,
        },
        hls: {
            type: 'string',
            isRequired: true,
        },
        dash: {
            type: 'string',
            isRequired: true,
        },
    },
} as const;
